import { Route, Routes } from "react-router-dom";
import { lazy, Suspense, useState } from "react";
import CustomerRoute from "./routes/CustomerRoute";
import ErrorBoundary from "./component/common/ErrorBoundary";
import RouteFallback from "./component/common/RouteFallback";
import SEO from "./component/common/SEO";

const StorefrontLayout = lazy(() => import("./layouts/StorefrontLayout"));
const HomeNew = lazy(() => import("./Pages/HomeNew"));
const Shopnew = lazy(() => import("./Pages/ShopNew"));
const Productdetails = lazy(() => import("./Pages/Productdetails"));
const Blog = lazy(() => import("./Pages/Blog"));
const Blogdetails = lazy(() => import("./Pages/Blogdetails"));
const About = lazy(() => import("./Pages/About"));
const Cart = lazy(() => import("./Pages/Cart"));
const Contact = lazy(() => import("./Pages/Contact"));
const Checkout = lazy(() => import("./Pages/Checkout"));
const Faq = lazy(() => import("./Pages/Faq"));
const Otp = lazy(() => import("./Pages/Otp"));
const Ordersuccess = lazy(() => import("./Pages/Ordersuccess"));
const PaymentSuccess = lazy(() => import("./Pages/PaymentSuccess"));
const Ordertracking = lazy(() => import("./Pages/Ordertracking"));
const Wishlist = lazy(() => import("./Pages/Wishlist"));
const Account = lazy(() => import("./Pages/Account"));
const Login = lazy(() => import("./Pages/Login"));
const Privacy = lazy(() => import("./Pages/Privacy"));
const Termscondition = lazy(() => import("./Pages/Terms&condition"));
const Returnpolicy = lazy(() => import("./Pages/Returnpolicy"));
const ShippingPolicy = lazy(() => import("./Pages/Shippingpoilicy"));
const Mission = lazy(() => import("./Pages/Mission"));
const Vision = lazy(() => import("./Pages/Vision"));
const Forgot = lazy(() => import("./Pages/Forgot"));
const Signup = lazy(() => import("./Pages/Signup"));
const OffersPage = lazy(() => import("./Pages/Offer"));
const Coupon = lazy(() => import("./Pages/Coupon"));
const LoginNew = lazy(() => import("./Pages/LoginNew"));

function App() {
  const [showLoginModal, setShowLoginModal] = useState(false);

  return (
    <ErrorBoundary>
      <SEO />
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          {/* ===== PUBLIC ROUTES ===== */}
          <Route element={<StorefrontLayout />}>
            <Route path="/" element={<HomeNew setShowLoginModal={setShowLoginModal} />} />
            <Route path="/Shop" element={<Shopnew setShowLoginModal={setShowLoginModal} />} />
            <Route path="/Blog" element={<Blog />} />
            <Route path="/Blogdetails/:id" element={<Blogdetails setShowLoginModal={setShowLoginModal} />} />
            <Route path="/About" element={<About />} />
            <Route path="/Contact" element={<Contact />} />
            <Route path="/Faq" element={<Faq />} />
            <Route path="/Offerspage" element={<OffersPage />} />
            <Route path="/Coupon" element={<Coupon setShowLoginModal={setShowLoginModal} />} />
            <Route path="/Productdetails/:id" element={<Productdetails setOpen={setShowLoginModal} />} />
            <Route path="/Checkout" element={<Checkout setShowLoginModal={setShowLoginModal} />} />
            <Route path="/Ordersuccess/:orderId" element={<Ordersuccess />} />
            <Route path="/Ordertracking/:orderId" element={<Ordertracking />} />
            <Route path="/Privacy" element={<Privacy />} />
            <Route path="/Terms" element={<Termscondition />} />
            <Route path="/Return" element={<Returnpolicy />} />
            <Route path="/Shipping" element={<ShippingPolicy />} />
            <Route path="/Mission" element={<Mission />} />
            <Route path="/Vision" element={<Vision />} />
            <Route
              path="/Cart"
              element={
                <CustomerRoute setShowLoginModal={setShowLoginModal}>
                  <Cart setShowLoginModal={setShowLoginModal} />
                </CustomerRoute>
              }
            />
            <Route
              path="/Wishlist"
              element={
                <CustomerRoute setShowLoginModal={setShowLoginModal}>
                  <Wishlist setShowLoginModal={setShowLoginModal} />
                </CustomerRoute>
              }
            />
            <Route
              path="/Account"
              element={
                <CustomerRoute setShowLoginModal={setShowLoginModal}>
                  <Account setShowLoginModal={setShowLoginModal} />
                </CustomerRoute>
              }
            />
          </Route>

          <Route path="/Otp" element={<Otp />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/Login" element={<Login />} />
          <Route path="/Forgot" element={<Forgot />} />
          <Route path="/Signup" element={<Signup />} />
        </Routes>
      </Suspense>

      {showLoginModal && (
        <Suspense fallback={null}>
          <LoginNew setOpen={setShowLoginModal} />
        </Suspense>
      )}

      <div className="theme-option">
        <div className="back-to-top">
          <a
            id="back-to-top"
            type="button"
            aria-label="Back to top"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            <i className="fas fa-chevron-up"></i>
          </a>
        </div>
      </div>
    </ErrorBoundary>
  );
}

export default App;
